import { useState } from "react";
import { MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";

interface GoogleMapsEmbedProps {
  src: string;
  title?: string;
  className?: string;
  height?: string;
}

export function GoogleMapsEmbed({
  src,
  title = "Google Maps",
  className = "",
  height = "400px",
}: GoogleMapsEmbedProps) {
  const [accepted, setAccepted] = useState(false);

  if (accepted) {
    return (
      <iframe
        src={src}
        width="100%"
        height={height}
        style={{ border: 0 }}
        allowFullScreen={false}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title={title}
        className={`grayscale hover:grayscale-0 transition-all duration-700 ${className}`}
      />
    );
  }

  return (
    <div
      className={`flex flex-col items-center justify-center gap-6 bg-secondary/50 border border-border rounded-sm p-8 text-center ${className}`}
      style={{ height }}
    >
      <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
        <MapPin className="w-8 h-8 text-primary" />
      </div>
      <div className="max-w-sm">
        <p className="font-bold text-foreground text-lg mb-2">Google Maps</p>
        <p className="text-sm text-muted-foreground leading-relaxed">
          Diese Karte wird von Google Maps bereitgestellt. Beim Laden werden
          Daten (inkl. Ihrer IP-Adresse) an Google LLC in den USA übertragen.
          Weitere Informationen finden Sie in unserer{" "}
          <a
            href="/datenschutz"
            className="text-primary underline hover:text-primary/80"
          >
            Datenschutzerklärung
          </a>
          .
        </p>
      </div>
      <Button
        onClick={() => setAccepted(true)}
        className="bg-accent text-accent-foreground hover:bg-accent/90 font-bold"
      >
        Karte jetzt laden
      </Button>
    </div>
  );
}
